/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CustomMetricConfigurationListRequestContext {
    getFixupPrototypeFunction() { return CustomMetricConfigurationListRequestContext.fixupPrototype; }

    static newInstance(model: Partial<CustomMetricConfigurationListRequestContext>): CustomMetricConfigurationListRequestContext {
        let obj = Object.assign(new CustomMetricConfigurationListRequestContext(), model);
        CustomMetricConfigurationListRequestContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CustomMetricConfigurationListRequestContext>): CustomMetricConfigurationListRequestContext {
        if (!model) return null;
        return CustomMetricConfigurationListRequestContext.newInstance(<CustomMetricConfigurationListRequestContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CustomMetricConfigurationListRequestContext) {
        if (!obj) return;

        models.CustomMetricConfigurationListRequestContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CustomMetricConfigurationListRequestContext): boolean {
        Object.setPrototypeOf(obj, CustomMetricConfigurationListRequestContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant id to filter configurations.
     */
    tenant_id: string;

    /**
     * Cloud Account Id  associated with custom metrics.
     */
    service_account_id: string;

    /**
     * Region in which custom metrics were created
     */
    regions: Array<string>;

    /**
     * Name of the Resource.
     */
    resource: string;

    /**
     * The namespace for the metric specified in metric_name.
     */
    metric_namespace: string;

    /**
     * Status of the custom Metric Configuration
     */
    status: models.CustomMetricConfigurationStatus;

}
